module.exports = __webpack_public_path__ + "media/business-studies.9790aa74.mp4";